import { colors } from '@/libs/react-components'
import styled from 'styled-components'

const LayoutWithBackGroundNeutral = styled.div`
    background-color: ${colors.neutral[95]};
`
export { LayoutWithBackGroundNeutral }
